import React from 'react';
import { resolveCampaignPersonalized } from '../utils/campaignTypeDisplay';

const CampaignTypeBadge = ({
  campaign,
  personalized,
  variant,
  compact = true,
  className = '',
  onClick,
  active = false,
}) => {
  const isTotal = variant === 'total';
  const isPersonal = isTotal ? false : personalized ?? resolveCampaignPersonalized(campaign);
  const label = isTotal
    ? 'Toplam'
    : isPersonal
      ? compact
        ? 'B.Ö'
        : 'Bana Özel'
      : compact
        ? 'G'
        : 'Genel';
  const sizeClass = compact
    ? 'min-w-[2.25rem] justify-center px-2.5 py-1 text-sm font-bold'
    : 'px-2.5 py-1 text-xs font-semibold';

  const baseClass = isTotal
    ? `bg-indigo-100 text-indigo-700 ring-indigo-200 ${active ? 'ring-2 ring-indigo-500' : 'ring-1'}`
    : isPersonal
      ? `bg-violet-100 text-violet-700 ring-violet-200 ${active ? 'ring-2 ring-violet-500' : 'ring-1'}`
      : `bg-slate-100 text-slate-700 ring-slate-200 ${active ? 'ring-2 ring-slate-500' : 'ring-1'}`;

  const interactiveClass = onClick
    ? 'cursor-pointer transition-all hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1'
    : '';

  const sharedClassName = `inline-flex shrink-0 items-center rounded-full ${sizeClass} ${baseClass} ${interactiveClass} ${className}`;

  const title = compact && !isTotal ? (isPersonal ? 'Bana Özel' : 'Genel') : undefined;

  if (onClick) {
    return (
      <button
        type="button"
        title={title}
        aria-pressed={active}
        onClick={onClick}
        className={sharedClassName}
      >
        {label}
      </button>
    );
  }

  return (
    <span title={title} className={sharedClassName}>
      {label}
    </span>
  );
};

export default CampaignTypeBadge;
